import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { EmptyState } from "../../Components/PageState/PageState";
const NotFound = () => <EmptyState title="Page not found">The requested page does not exist. <Button as={Link} to="/" variant="link">Return home</Button></EmptyState>;
export default NotFound;
